<template>
  <!-- 底部公共 -->
  <div id="bottom" class="bottom">
    <!-- <div class="bottom_tit" @click="tomenu('http://subscribe.boyuancb.com/')">
      <p>欢迎订阅<i class="iconfont icon-rightarrow"></i></p>
    </div> -->
    <div class="bottomB">
      <div class="foot">
        <p style="margin-top:10px;">  copyright@2009-2023 人民卫生出版社《中国血管外科杂志（电子版）》编辑部 中山大学附属第一医院(广州)期刊有限责任公司</p>
        <p>地址：广州市越秀区竹丝岗二马路5号龙珠大厦写字楼2楼&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮编：510080 电话：020-87363189  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;E-mail:zgxgw@126.com</p>

        <p style="cursor: pointer;" @click="jump">网站备案号：粤ICP备10090623号-10</p>
      </div>
    </div>
    <!-- <div class="bottomf">
      <ul>
        <li>关于我们</li>
        <li>法律声明</li>
        <li>在线投稿</li>
        <li>在线订阅</li>
        <li>版权声明</li>
        <li>联系我们</li>
        <li>网站地图</li>
      </ul>
    </div> -->
    <div class="bottomC">
      <div class="foot">
        <p class="foot_p">浏览量：{{hits}}</p>
        <div class="foot_teo">
          <p>地址：河北省&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮编：430030&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：010-8888888</p>
          <p>版权归《骨科临床与研究杂志》编辑部所有 </p>

          <p>网站备案/许可证号：鄂ICP备19011190号</p>
        </div>
      </div>
    </div>
    <div class="bottomD">
      <div class="bottomD_Code">
        <div class="bottomD_Code_img">
          <!-- <img src="../../../../static/中国循环杂志/wx.png" alt=""> -->
        </div>
        <p>微信公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router/index'
import $ from 'jquery'
import Swiper from 'swiper'
import axios from 'axios'
import { mixin } from "../../../assets/script/scrollnav"
import { pagination } from '../../../../src/assets/mixin/data-table'

export default {
  name:'bottom',
  mixins: [pagination],
  data(){
    return{
      strategic:[

      ],
      navi:'',
      circleListD:[],
      hits:'',
      lmUrl:'http://cjhc.boyuancb.com/ADmin'
    }
  },
  methods:{
    jump(){
      window.open('https://beian.miit.gov.cn')
    },
    getData(){
      var params = new URLSearchParams();
      params.append('JournalID', 201910280001);  //期刊ID，固定不变
      params.append('ChannelID', 2519);
      axios.post('/FriendlyLinkWebAPI/GetList',params).then((res) => {
				this.strategic = res.data.data
        this.strategic.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10);
          // item.LogoUrl = this.lmUrl + item.LogoUrl
        })
      })
		},
		toMenu(url){
			window.open(url);
		},
    getHits(){
      var params = new URLSearchParams();
      params.append('JournalID', 201910280001);  //期刊ID，固定不变
      axios.post('/SiteConfigWebAPI/GetSiteAccessCount',params).then((res) => {
		    this.hits = res.data.data
      })
    }
  },
  mounted(){

  },
  created(){
    this.getData();
    this.getHits();
  }
}
</script>

<style lang="less" scoped>
  #bottom{
    width:100%;
    height:100%;
    margin-top: 32px;
    .bottom_tit{
      width:1200px;
      height:53px;
      margin: 0 auto;
      line-height: 53px;
      p{
        text-align: center;
        font-size: 24px;
        color: #E90107;
        font-weight: bold;
        cursor: pointer;
        i{
          color: #888888;
          margin-left: 10px;
          font-size: 18px;
        }
      }
    }
		.bottomB{
			width:100%;
      height:178px;
      background: url('../../../../static/bbtm.png');
      // background:linear-gradient(0deg,rgba(163,0,21,1),rgba(230,0,18,1));
      margin-top: 22px;
			.foot{
				width:1200px;
				height:100%;
				margin:0 auto;
				position:relative;
        text-align:center;
				p{
					font-size:16px;
					position:relative;
					top:35px;
          color:#fff;
          margin-bottom: 11px;
				}
			}
    }
    .bottomf{
      width: 100%;
      height: 48px;
      background: #BEBEBE;
      ul{
        margin: 0 auto;
        height: 48px;
        margin-left:27%;
        li{
          width: 112px;
          text-align: center;
          border-right: 1px solid #6D6D6D;
          float: left;
          color: #000;
          font-size: 16px;
          cursor: pointer;
          height: 20px;
          line-height: 20px;
          margin-top: 14px;
        }
        li:last-child{
          border: none;
        }
      }
    }
	}
  @media screen and (min-width:1010px){
    .bottomC{
      display: none;
    }
    .bottomD{
      display: none;
    }
    .strategic{
      display: none;
    }
  }
	@media screen and (max-width:1010px){
		#bottom{
      width:100%;
      .bottom_tit{
        width: 100%!important;
      }
      .foot{
        width: 100%!important;
      }
      .foot_teo{
        width: 100%!important;
      }
      .bottomB{
        display: none;
      }
      .bottomC{
        width:100%;
        margin-top: 19px;
        background:#b80000;
        .foot{
          width:100%;
          height:100%;
          margin:0 auto;
          position:relative;
          text-align:center;
          .foot_p{
            font-size:16px;
            padding-top: 12px;
            color:#fff;
          }
          .foot_teo{
            width:1200px;
            margin-top:19px;
            p:last-child{
              margin-bottom: 0px;
              padding-bottom: 8px;
            }
            p{
              font-size:14px;
              color:#fff;
              margin-bottom:8px;
            }
          }
        }
      }
      .bottomD{
        width:100%;
        height: auto;
        background:#b80f1a;
        .bottomD_Code{
          width: 70px;
          height: 100px;
          margin: 0 auto;
          position: relative;
          top: 9px;
          .bottomD_Code_img{
            width: 70px;
            height: 70px;
            background: #fff;
            img{
              width: 60px;
              position: relative;
              left: 5px;
              top: 5px;
            }
          }
          p{
            color: #fff;
            text-align: center;
          }
        }
      }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/public/bottom/index.vue